import {
  abbreviate,
  ColorMode,
  Flex,
  Popover,
  Switch,
  Text,
  TopNav,
} from '@revolut-internal/ui-kit'
import { useMemo } from 'react'

import type { useLayoutProvider } from 'containers/Bootstrap/providers/LayoutProvider/hooks/useLayoutProvider'
import { auth } from 'lib/auth'

const MENU_ITEMS = [
  {
    id: 'rmail',
    icon: 'Envelope' as const,
    title: 'RMail',
  },
]

type LayoutValue = ReturnType<typeof useLayoutProvider>

export function useTopNavConfig(layout: LayoutValue) {
  const { themeMode, toggleThemeMode } = layout

  return useMemo(() => {
    const user = auth.getUser()
    const menu = (
      <TopNav.Menu
        items={user ? MENU_ITEMS : []}
        value={user ? 'rmail' : undefined}
        defaultCollapse="force"
      />
    )

    const logo = <TopNav.Logo useIcon="LogoRevolut">RMail</TopNav.Logo>

    if (!user) {
      return {
        logo,
        menu,
        profile: undefined,
        appSwitcher: undefined,
      }
    }

    const fullName = user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName

    return {
      logo,
      menu,
      profile: (
        <TopNav.Profile
          name={fullName}
          label={abbreviate(fullName)}
          uuid={user.id}
          data-testid="sidebar-userdropdown-button"
        >
          <Popover.Group>
            <Popover.Item useIcon="Contrast">
              <Flex justifyContent="space-between">
                <Text>Dark mode</Text>
                <Switch
                  title="Darkmode"
                  checked={themeMode === ColorMode.DARK}
                  onChange={toggleThemeMode}
                />
              </Flex>
            </Popover.Item>
          </Popover.Group>
          <Popover.Group>
            <Popover.Item
              use="button"
              useIcon="LogoutDoor"
              iconColor="red"
              onClick={() => auth.logout()}
            >
              Logout
            </Popover.Item>
          </Popover.Group>
        </TopNav.Profile>
      ),
      appSwitcher: undefined,
    }
  }, [themeMode, toggleThemeMode])
}
